import { connect } from 'react-redux';
import { getTheme, getShowMatureContent, getIsLoggedIn, getCurrentUser, getPointsCount, getCsrfToken, getCurrentUserHasCore, getFeedbackUrl, getVerificationEmailAddress, getCanEnableToggleMatureContent, getThemeSkin, getFragmentsBalance, getCoreLevel, getTierСount, getContentFilter } from '../publicSession/selectors';
import { toggleMature, toggleTheme, setTheme, setThemeSkin } from '../publicSession/actions';
import { userLogoutButtonClicked } from './redux/actions';
import { flagEnabled } from '../redux/flags/selectors';
import { pushModal, pushUserSettingsModal } from '../Modals/redux/actionCreators';
import { ModalType } from '../Modals/redux/types';
const mapStateToProps = (state)=>({
        csrfToken: getCsrfToken(state),
        currentUser: getCurrentUser(state),
        isLoggedIn: getIsLoggedIn(state),
        verificationEmail: getVerificationEmailAddress(state),
        theme: getTheme(state),
        themeSkin: getThemeSkin(state),
        matureContent: getShowMatureContent(state),
        sfwbrowse: flagEnabled(state, 'sfwbrowse'),
        contentFilter: getContentFilter(state),
        pointsCount: getPointsCount(state),
        fragmentsBalance: getFragmentsBalance(state),
        hasCoreMembership: getCurrentUserHasCore(state),
        coreLevel: getCoreLevel(state),
        feedbackUrl: getFeedbackUrl(state),
        canEnableMatureContent: getCanEnableToggleMatureContent(state),
        hasSubscriptions: getTierСount(state) > 0,
        hasCryptoWallet: flagEnabled(state, 'crypto_wallet')
    });
const mapDispatchToProps = {
    toggleTheme,
    toggleMature,
    pushUserSettingsModal,
    setTheme,
    setThemeSkin,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
    showWeb3WalletModal: ()=>pushModal(ModalType.WEB3_WALLET, {
            wrapInModal: false
        })
};
export default connect(mapStateToProps, mapDispatchToProps);
